const defaultEthereumAccountAtIndex = (pathIndex) => {
    return {
        curve: "CURVE_SECP256K1",
        pathFormat: "PATH_FORMAT_BIP32",
        path: `m/44'/60'/${pathIndex}'/0/0`,
        addressFormat: "ADDRESS_FORMAT_ETHEREUM",
    };
};
const DEFAULT_ETHEREUM_ACCOUNTS = [
    defaultEthereumAccountAtIndex(0),
];
const defaultSolanaAccountAtIndex = (pathIndex) => {
    return {
        pathFormat: "PATH_FORMAT_BIP32",
        path: `m/44'/501'/${pathIndex}'/0'`,
        curve: "CURVE_ED25519",
        addressFormat: "ADDRESS_FORMAT_SOLANA",
    };
};
const DEFAULT_SOLANA_ACCOUNTS = [
    defaultSolanaAccountAtIndex(0),
];

export { DEFAULT_ETHEREUM_ACCOUNTS, DEFAULT_SOLANA_ACCOUNTS, defaultEthereumAccountAtIndex, defaultSolanaAccountAtIndex };
//# sourceMappingURL=turnkey-helpers.mjs.map
